
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackEvent, getStoredMeasurementId, initializeGA } from '@/services/analytics';

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA if measurement ID is stored
    const measurementId = getStoredMeasurementId();
    if (measurementId) {
      initializeGA(measurementId);
    }
  }, []);

  useEffect(() => {
    // Track page views on route changes
    const measurementId = getStoredMeasurementId();
    if (measurementId) {
      trackPageView(location.pathname);
    }
  }, [location]);

  return {
    trackEvent: (action: string, category: string, label?: string, value?: number) => {
      const measurementId = getStoredMeasurementId();
      if (measurementId) {
        trackEvent(action, category, label, value);
      }
    }
  };
};
